<template>
  <div id="bg-image">
    <link-password-link-otp />
  </div>
</template>
<script>
  import PasswordResetOtp from '../process/Register/PasswordResetOtp.vue';
    export default {
      name: 'ResetLinkValidation',
      components: {
       'link-password-link-otp': PasswordResetOtp,
      },
    };
</script>
